// Copyright (C) 2026 FlexiProof. All rights reserved.
//
// This source code file is a part of free software licensed under the terms of
// the MIT License as published by the Massachusetts Institute of Technology:
// you can use, copy, modify and distribute any part of it without limitation,
// subject to the conditions contained within that license.
//
// This source code file, and the software it forms a part of, IS PROVIDED "AS
// IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED. See the MIT License
// for more details.
//
// You should have received a copy of the MIT License along with this source
// code file in the root of this repository. If not, see one of the following
// 3rd party sites for a copy of the license template:
// - <https://opensource.org/licenses/MIT>
// - <https://choosealicense.com/licenses/mit>
// - <https://spdx.org/licenses/MIT>

/**
 * @file
 * @author James Reid
 */

// @ts-check

// @@imports-package
import { ListSelect } from "../../../components/elements/ListSelect.js"

// @@imports-submodule
import { getMembraneBreakdown } from "./breakdowns/index.js"

// @@imports-utils
import { cloneTemplate } from "../../../utils/index.js"

// @@imports-types
import { State } from "../../../types/index.js"
import { Bom, EpdmCalculator, Extra, MEMBRANES, MEMBRANE_TYPES, Membrane } from "../../../../../package/index.js"
import { App } from "../../../app/App.js"

// @@body
/**
 * 
 * @param {HTMLElement} card
 * @param {Bom} bom
 * @param {State} state
 */
const populateExtraCard = (card, bom, state) => {
    for (const { product, quantity } of bom.lineItems) {
        if (!(product instanceof Extra)) { continue }

        const lineItem = cloneTemplate("extras-line-item");
        /** @type {HTMLSpanElement} */ (lineItem
            .querySelector("span.product"))
            .innerText = product.name;
        /** @type {HTMLSpanElement} */ (lineItem
            .querySelector("span.price"))
            .innerText = `${product.price.toFixed(2)}`;
        /** @type {HTMLSpanElement} */ (lineItem
            .querySelector("span.quantity"))
            .innerText = `${quantity}`;

        /** @type {HTMLSpanElement} */ (lineItem
            .querySelector("span.button.increase"))
            .addEventListener("click", () => {
                // state.quote.calculator?.extrasBom.addLineItem(product, 1)
                card.dispatchEvent(new Event("change"))
                App.dispatchStateUpdated()
            });

        /** @type {HTMLSpanElement} */ (lineItem
            .querySelector("span.button.decrease"))
            .addEventListener("click", () => {
                if (quantity > 0) {
                    // state.quote.calculator?.extrasBom.addLineItem(product, - 1)
                    card.dispatchEvent(new Event("change"))
                    App.dispatchStateUpdated()
                }
            })

        const image = document.createElement("img")
        image.src = product.imageUrl;
        /** @type {HTMLDivElement} */ (lineItem
            .querySelector("div.horizontal-container"))
            .append(image)

        // const details = cloneTemplate(`extras-product-details-${product.code}`);
        // /** @type {HTMLDivElement} */ (lineItem
        //     .querySelector("collapsible-container div.content"))
        //     .append(details)

        card.append(lineItem)
    }
}

// @@exports
export { populateExtraCard }
